<template>
  <modal
    :title="'Selecting Parasut Customer'"
    :size="'xl'"
    @close="$emit('close')"
  >
    <template #content>
      <load-area v-if="data==null"></load-area>
      <dataTable
        v-if="data!=null"
        :name="'Customers'"
        :key="tableTypeModel"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        @cellClicked="$emit('select',$event.data.Id)"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.Id==selectId;
            // return params?.data?.minEndDate<31 && params?.data?.minEndDate>15;
          }
        }"
      ></dataTable>
    </template>
  </modal>
</template>

<script>

export default 
  {
  name: "parasut",
  props: {
    data: Array,
    selectId:Number
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
        },
        {
          headerName: "ShortName",
          field: "ShortName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 2,
          minWidth: 140,
        },
        {
          headerName: "Balance",
          field: "Balance",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
        }
      ],
    };
  },
};
</script>

<style scoped>
.nav-tabs .nav-item {
  vertical-align: middle;
  overflow: hidden;
}
</style>
